import { Response } from "react-select-async-paginate";
import AsyncPaginateBootstrap from "../react-select-bootstrap/AsyncPaginateBootstrap";
import { getList } from "../../api/generics";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import DocumentSubcategory from "../../models/document-subcategory";

const RECORS_PER_SEARCH = 20;

type DocumentSubcategoriesSelectProps = {
  value: readonly DocumentSubcategory[];
  onChange: (_: readonly DocumentSubcategory[]) => void;
  isDisabled?: boolean;
};

const DocumentSubcategoriesSelect: React.FC<
  DocumentSubcategoriesSelectProps
> = ({ value, onChange, isDisabled }) => {
  const companyId = useSelector(
    (state: RootState) => state.company.data.company.id
  );
  const loadOptions = async (
    s: string,
    currentOpts: readonly (
      | DocumentSubcategory
      | { options: DocumentSubcategory[]; label?: string }
    )[]
  ): Promise<
    Response<
      DocumentSubcategory,
      { options: DocumentSubcategory[]; label?: string },
      any
    >
  > => {
    let additionalParams: Map<string, string> | undefined = new Map<
      string,
      string
    >();

    additionalParams.set("company_id", companyId!.toString());

    if (s !== "") {
      additionalParams.set("search", s);
    }

    const dataPaginated = await getList<DocumentSubcategory>(
      "/document_subcategories/",
      RECORS_PER_SEARCH,
      currentOpts.length,
      additionalParams
    );

    let newOpts: DocumentSubcategory[] = [];
    let count = 0;

    if (dataPaginated.data !== undefined) {
      newOpts = dataPaginated.data.items;
      count = dataPaginated.data.count;
    }

    const hasMore = currentOpts.length + newOpts.length < count;

    return {
      options: newOpts,
      hasMore: hasMore,
    };
  };
  return (
    <AsyncPaginateBootstrap
      placeholder="Selecciona las Subcategorías de Documento"
      onChange={onChange}
      isMulti={true}
      debounceTimeout={300}
      loadOptions={loadOptions}
      getOptionLabel={(option: DocumentSubcategory) => `${option.name}`}
      getOptionValue={(option: DocumentSubcategory) => `${option.id}`}
      value={value}
      isDisabled={isDisabled}
    />
  );
};

export default DocumentSubcategoriesSelect;
